import { Divider } from "@mui/material";
import { dividerStyle, dotStyle } from "./utils";

type Props = {
  align?: "top" | "bottom";
};

export const TimelineDot = ({ align = "top" }: Props) => {
  const beforeStyles = {
    ...dotStyle,
    transform:
      align === "bottom" ? "translate(-50%, 50%)" : "translate(-50%, -50%)",
  };

  if (align === "top") {
    beforeStyles.top = 0;
  } else if (align === "bottom") {
    beforeStyles.bottom = 0;
  }

  const styles = {
    ...dividerStyle,
    "&::before": beforeStyles,
  };

  if (align === "bottom") {
    styles.height = "12px";
  }

  return <Divider orientation="vertical" sx={styles} />;
};
